import { stringToElements } from '../helpers/index.js';
import { getOpenWalletLink } from '../pricing/links.js';

// Insert the My Wallet Widget
export const insertSearchBudget = (API, config, location ) => {
    const {
        searchByBudget,
        linkColorConfig
    } = config;
    const linkColor = linkColorConfig.length > 0 && linkColorConfig[0];
    API.insert(location, async (elem) => {
        const pricingFacetTemplate = `
            <button class="btn btn-unstyled btn-my-wallet-integration p-0 border-0 mt-4 ${linkColor}">
                <span class="mywallet-icon light"></span>
                <span class="wallet-link"></span>
            </button>
        `;

        const markup = await stringToElements(pricingFacetTemplate);
        const textColor = linkColor === 'light'? 'text-neutral-0' : 'text-body';
        const openWalletLink = getOpenWalletLink(searchByBudget, `${textColor} text-no-decoration ddc-font-size-small`, false, false, null, 'budget');
        markup.querySelector('.wallet-link').appendChild(openWalletLink);
        API.append(elem, markup);
    });
}
